export enum FUNDING_SOURCE {
  PAYPAL = 'paypal',
  VENMO = 'venmo',
  APPLEPAY = 'applepay',
  ITAU = 'itau',
  CREDIT = 'credit',
  PAYLATER = 'paylater',
  CARD = 'card',
  IDEAL = 'ideal',
  SEPA = 'sepa',
  BANCONTACT = 'bancontact',
  GIROPAY = 'giropay',
  SOFORT = 'sofort',
  EPS = 'eps',
  MYBANK = 'mybank',
  P24 = 'p24',
  VERKKOPANKKI = 'verkkopankki',
  PAYU = 'payu',
  BLIK = 'blik',
  TRUSTLY = 'trustly',
  ZIMPLER = 'zimpler',
  MAXIMA = 'maxima',
  OXXO = 'oxxo',
  BOLETOBANCARIO = 'boletobancario',
  WECHATPAY = 'wechatpay',
  MERCADOPAGO = 'mercadopago',
  MULTIBANCO = 'multibanco',
}
